// @flow strict
const PAGINATION = {
  PREV_PAGE: '← Precedenti',
  NEXT_PAGE: '→ Successivi'
};

export default PAGINATION;
